import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/core/redux/store";
import { getSupplierResponsesAllThunk } from "@/core/redux/thunks/supplierResponsesAllThunk";
import TableHeader from "./table-header/table-header";
import TableBody from "./table-body/table-body";
import TablePagination from "./table-pagination/table-pagination";
import { useEffect, useRef } from "react";

export default function Table() {
  const dispatch = useDispatch();
  const companyId = useSelector((state: RootState) => state.user.me?.company?.id);
  const { sort, search, status, pagination } = useSelector(
    (state: RootState) => state.supplierResponsesAll
  );
  
  // Track if this is the initial mount
  const isInitialMount = useRef(true);

  // Fetch data when sort, search, or status changes
  useEffect(() => {
    // Skip the initial mount as data is already fetched elsewhere
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    if (companyId) {
      dispatch(
        getSupplierResponsesAllThunk({
          companyId,
          offset: 0, // Reset to first page when filters/sort change
          limit: pagination.limit,
          search: search || undefined,
          sortBy: sort.sortBy || undefined,
          sortOrder: sort.sortOrder || undefined,
        }) as any
      );
    }
  }, [sort.sortBy, sort.sortOrder, search, status, companyId, dispatch, pagination.limit]);

  const handlePaginationChange = (pagination: {
    pageIndex: number;
    pageSize: number;
  }) => {
    if (companyId) {
      const offset = pagination.pageIndex * pagination.pageSize;
      dispatch(
        getSupplierResponsesAllThunk({
          companyId,
          offset,
          limit: pagination.pageSize,
          search: search || undefined,
          sortBy: sort.sortBy || undefined,
          sortOrder: sort.sortOrder || undefined,
        }) as any
      );
    }
  };

  return (
    <>
      <div className="w-full rounded-[12px] border border-border">
        <TableHeader />
        <TableBody />
      </div>
      <TablePagination handlePaginationChange={handlePaginationChange} />
    </>
  );
}
